<i18n>
{
"en": {
  "NEWPASSWORD": "New Password",
  "CONFIRMPASSWORD": "Confirm Password",
  "CHANGEPASSWORD": "Change Password",
  "CHANGING": "Changing..",
  "INFOTIP": "Use at least 8 characters including <u>Lowercase, Uppercase Numbers <br/>and Special Characters</u>. Don’t use a password from another site, <br/>phrases from <u>Username</u> or something too obvious like your pet’s name.",
  "ERROR": "Error",
  "CLOSE": "Close",
  "ISREQUIRED": "is required.",
  "MUSTBEATLEASTCHARACTERSINLENGTH": "must be at least {len} characters in length.",
  "CANNOTEXCEEDCHARACTERSINLENGTH": "cannot exceed {len} characters in length.",
  "DIDNOTMATCH": "did not match with confirm password.",
  "PASSWORDVALIDATION": "seems too weak.",
  "YOURRECORDIDNOTMATCH": "Sorry, your record did not match in our records.",
  "CANNOTCONTAINPHRASESFROMYOURUSERNAME": "cannot contain phrases from your username.",
  "SUCCESS": "Your password is successfully changed!"  
},
"ar": {

}
}
</i18n>
<template>
    <div>
    <div class="form-reset">
        <div align="center">
          <img :src="require('../assets/img/logo-login.png')" />
        </div>
        <div align="center">
    </div>
    <el-form  ref="ruleForm" label-width="120px" :model="ruleForm" :rules="rules" label-position="top">
        <el-row>
          <el-form-item label="New Password" prop="pass">
             <el-tooltip placement="left-start">
                 <div slot="content">Use at least 8 characters including <u>Lowercase, Uppercase Numbers <br/>and Special Characters</u>. Don’t use a password from another site, <br/>phrases from <u>Username</u> or something too obvious like your pet’s name.</div>
                <el-input type="password" size="large" class="form-control" v-model="ruleForm.pass" auto-complete="off"></el-input>
             </el-tooltip>
          </el-form-item>
        </el-row>
        <el-form-item label="Confirm Password" prop="checkPass">
            <el-input type="password" size="large" class="form-control" @keyup.native.enter="passwordReset('ruleForm')" v-model="ruleForm.checkPass" auto-complete="off"></el-input>
        </el-form-item>
        </el-row>
        <el-progress v-show="ruleForm.pass" ref="meter" :percentage="currentStrength.percentage" :status="currentStrength.status"></el-progress>
    </el-form>
    <div class="form-footer">
      <div class="curve-down-area"></div>
      <div class="down-curve down-curve2"></div>
      <div class="login-page-container">
          <div class="form-reset">
              <el-row class="submit_button">
            <el-button type="submit"  @click="passwordReset('ruleForm')" size="large" class="btn-lg"  style="margin-bottom:10px; width:480px" v-text="changing ? 'Changing..' : 'Change Password'"></el-button>
              </el-row>
          </div>
      </div>
    </div>
    </div>
    <el-dialog title="Error" v-model="error" size="tiny">
      <div class="el-alert el-alert--error">
        <i class="el-alert__icon el-icon-circle-cross is-big"></i>
        <div class="el-alert__content">
          <span class="el-alert__title is-bold" :key="index" v-for="(messageError, index) in message">{{messageError}}<br/></span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="error = false">Close</el-button>
      </span>
    </el-dialog>     
    </div>   
</template>

<script>
  
  import _ from 'lodash'
  import { EventBus } from '../event-bus.js'
  let strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})')
  let mediumRegex = new RegExp('^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})')
  let strength = [{text: '', percentage: 0, status: ''}, {text: 'Strong', percentage: 100, status: 'success'}, {text: 'Medium', percentage: 60, status: ''}, {text: 'Weak', percentage: 20, status: 'exception'}]
  export default {
    components: {},
    data () {
      let valPass = (rule, value, callback) => {
        if (_.isEmpty(value)) callback(new Error('Please input the password'))
        else {
          if (!new RegExp('(?=.*[a-z])').test(value)) callback(new Error('The password must contain at least 1 lowercase alphabetical character'))
          else if (!new RegExp('(?=.*[A-Z])').test(value)) callback(new Error('The password must contain at least 1 uppercase alphabetical character'))
          else if (!new RegExp('(?=.*[0-9])').test(value)) callback(new Error('The password must contain at least 1 numeric character'))
          else if (!new RegExp('(?=.*[!@#\\$%\\^&\\*])').test(value)) callback(new Error('The password must contain at least one special character'))
          if (!new RegExp('(?=.{8,})').test(value)) callback(new Error('Please use at least 8 characters'))
          else if (!_.isEmpty(this.ruleForm.checkPass)) this.$refs.ruleForm.validateField('checkPass')
          callback()
        }
      }
      let valConfirmPass = (rule, value, callback) => {
        if (_.isEmpty(value)) {
          callback(new Error('Please input the password again'))
        } else {
          if (value !== this.ruleForm.pass) {
            callback(new Error('Two inputs don\'t match!'))
          }
          callback()
        }
      }
      return {
        ruleForm: {
          pass: null,
          checkPass: null
        },
        school: [],
        email: null,
        rules: {
          pass: [
            { validator: valPass, trigger: 'change' }
          ],
          checkPass: [
            { validator: valConfirmPass, trigger: 'change' }
          ]
        },
        currentStrength: {},
        message: null,
        changing: false,
        error: false
      }
    },
    watch: {
      'ruleForm.pass': function (val) {
        this.analyze(val)
      }
    },
    mounted () {
      this.currentStrength = strength[0]
      this.$refs.meter.$el.children[1].innerHTML = this.currentStrength.text
    },
    methods: {
      passwordReset (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) return this.doReset()
          return false
        })
      },
      printError (message) {
        let error = message.split(' ')
        return error[0] + ' ' + error[1] + '</br>'
      },
      doReset () {
        this.changing = true
        let postData = {pass: this.ruleForm.pass, checkPass: this.ruleForm.checkPass, schoolID: this.$route.params.id, rh: this.$route.query.rh}
        let self = this
        this.$http.post('/user/password', postData).then(function (response) {
          let data = response.data
          self.changing = false
          self.message = data.message
          self.error = data.error
          if (!self.error) {
            let userData = data.user_data
            localStorage.setItem('lang', userData.lang)
            EventBus.$emit('userData', userData)
            self.$router.push('/')
            return self.$message({message: 'Your password is successfully changed!', type: 'success'})
          }
        }).catch(function () {
        })
      },
      analyze (value) {
        if (strongRegex.test(value)) this.currentStrength = strength[1]
        else if (mediumRegex.test(value)) this.currentStrength = strength[2]
        else this.currentStrength = strength[3]
        this.$refs.meter.$el.children[1].innerHTML = '<b>' + this.currentStrength.text + '</b>'
      }
    }
  }
</script>

<style>
.form-reset .el-progress{width: 25%;float: right;}
.form-reset .el-progress-bar{width: 90%;}
.form-reset .el-progress-bar__inner{background-color: #20a0ff;}
.form-reset img{
    margin-top: 15px;
}
.form-reset form {
    max-width: 480px;
    margin: 0 auto;

}

.form-reset.content{ background-color: #f3f2ee}

.form-reset h2 {
    color: #4b4b4b;
    font-size: 30px;
    font-family: "MavenProLight3", Arial, sans-serif;
    line-height: 50px;
    margin: 13px 0 10px;

}
.form-footer {
    background-color: #f5c93c;
}

.login-page-container{min-height: 180px}
.down-curve2 {
    width: 100%;
}

.down-curve {
    background: #f3f2ee;
    height: 40px;
    margin: 0 auto;
    width: 25%;
}
/* line 153, ../scss/components/_general.scss */
.down-curve::before {
    content: "";
    background: #f5c93c;
    -webkit-border-top-right-radius: 30px;
    border-top-right-radius: 30px;
    float: left;
    height: 40px;
    width: 50%;
}
/* line 161, ../scss/components/_general.scss */
.down-curve::after {
    content: "";
    background: #f5c93c;
    -webkit-border-top-left-radius: 30px;
    border-top-left-radius: 30px;
    float: left;
    height: 40px;
    width: 50%;
}
/* line 160, ../scss/pages/web/_login.scss */
.down-curve2:before {
    border-top-left-radius: 0;
}
/* line 163, ../scss/pages/web/_login.scss */
.down-curve2:after {
    border-top-right-radius: 0;
}

/* line 167, ../scss/pages/web/_login.scss */
.curve-down-area {
    border-radius: 0 0 50px 50px;
    background-color: #f3f2ee;
    height: 40px;
}
.form-reset{text-align:center}
.form-reset img{width:125px}
.form-reset .form-control input{ text-align:center; border-radius: 25px;background-color:#f3ecd3; border: 1;}
.form-reset .form-control:active input, .form-reset input.form-control:focus input {
  background-color: #b2e3c2;
}
.form-reset button{border-radius: 25px;}
.form-reset .form-group{margin:0}
.form-reset label {height: 42px;
font-size: 16px;
line-height: 18px;
color: #373737;
padding-top: 12px; font-weight:normal}

.btn-lg{border-color: #2d2d2d;color:#000; background: none;font-size: 25px;}

.btn-lg:hover{
   background: #4b4b4b;
   border-color: #4b4b4b;
   color:#fff
}
 
.navbar-inverse .navbar-nav > .active > a{   border-bottom: 2px solid #f5c93c;background: none;}

.form-reset .form-control input {
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
}
</style>



// WEBPACK FOOTER //
// ResetPassword.vue?bac3a78a